import { render, staticRenderFns } from "./Preparacao.vue?vue&type=template&id=75b309de&scoped=true&"
import script from "./Preparacao.vue?vue&type=script&lang=js&"
export * from "./Preparacao.vue?vue&type=script&lang=js&"
import style0 from "./Preparacao.vue?vue&type=style&index=0&id=75b309de&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75b309de",
  null
  
)

export default component.exports